import { render } from "./EditDistributorDialog.vue?vue&type=template&id=6ae7ec02&scoped=true"
import script from "./EditDistributorDialog.vue?vue&type=script&lang=js"
export * from "./EditDistributorDialog.vue?vue&type=script&lang=js"

import "./EditDistributorDialog.vue?vue&type=style&index=0&id=6ae7ec02&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ae7ec02"]])

export default __exports__